import React from 'react';
import {
  Minus, ArrowUpRight, RectangleHorizontal, TrendingUp,
  Trash2, MousePointer2, Undo2, Type, Circle, Columns,
  MoveHorizontal, Maximize2,
} from 'lucide-react';

/**
 * Drawing tools available on the chart.
 */
export const DRAWING_TOOLS = {
  cursor: { id: 'cursor', label: 'Cursor', icon: MousePointer2 },
  fib: { id: 'fib', label: 'Fibonacci', icon: TrendingUp },
  hline: { id: 'hline', label: 'H-Line', icon: Minus },
  trendline: { id: 'trendline', label: 'Trend Line', icon: ArrowUpRight },
  ray: { id: 'ray', label: 'Ray', icon: ArrowUpRight },
  arrow: { id: 'arrow', label: 'Arrow', icon: ArrowUpRight },
  rect: { id: 'rect', label: 'Rectangle', icon: RectangleHorizontal },
  channel: { id: 'channel', label: 'Parallel Channel', icon: Columns },
  hrange: { id: 'hrange', label: 'H-Range', icon: MoveHorizontal },
  ellipse: { id: 'ellipse', label: 'Ellipse', icon: Circle },
  text: { id: 'text', label: 'Text', icon: Type },
};

/**
 * Toolbar for selecting drawing tools on the chart.
 */
export default function DrawingToolbar({
  activeTool,
  onToolChange,
  drawings,
  onUndo,
  onClearAll,
  selectedDrawing,
  onDeleteSelected,
}) {
  const tools = Object.values(DRAWING_TOOLS);

  return (
    <div className="flex items-center gap-1">
      {/* Tool buttons — scrollable on mobile */}
      <div className="flex items-center gap-0.5 bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 overflow-x-auto max-w-[55vw] sm:max-w-none sm:overflow-visible">
        {tools.map(tool => {
          const Icon = tool.icon;
          const isActive = activeTool === tool.id;
          return (
            <button
              key={tool.id}
              onClick={() => onToolChange(isActive ? 'cursor' : tool.id)}
              title={tool.label}
              className={`relative flex items-center justify-center w-7 h-7 sm:w-7 sm:h-7 rounded-md transition-all text-xs shrink-0 ${
                isActive
                  ? 'bg-blue-500 text-white shadow-sm'
                  : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-700 dark:hover:text-slate-200'
              }`}
            >
              <Icon size={14} />
            </button>
          );
        })}
      </div>

      {/* Undo / Delete selected / Clear */}
      {drawings.length > 0 && (
        <div className="flex items-center gap-0.5 bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 ml-1">
          <button
            onClick={onUndo}
            title="Undo last drawing"
            className="flex items-center justify-center w-7 h-7 rounded-md text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-700 dark:hover:text-slate-200 transition-all"
          >
            <Undo2 size={14} />
          </button>
          {selectedDrawing && (
            <button
              onClick={onDeleteSelected}
              title="Delete selected drawing"
              className="flex items-center justify-center w-7 h-7 rounded-md text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-500/10 hover:text-amber-600 dark:hover:text-amber-400 transition-all"
            >
              <Trash2 size={14} />
            </button>
          )}
          <button
            onClick={onClearAll}
            title="Clear all drawings"
            className="flex items-center justify-center w-7 h-7 rounded-md text-red-400 hover:bg-red-50 dark:hover:bg-red-500/10 hover:text-red-600 dark:hover:text-red-400 transition-all"
          >
            <Trash2 size={14} />
          </button>
        </div>
      )}
    </div>
  );
}
